import { __awaiter, __generator } from "tslib";
import { logError } from '@office-start/telemetry-service';
import { DeferredPromise, DeferredPromiseStatus, } from '../utils/DeferredPromise';
import { ModuleError } from './ModuleError';
var Module = /** @class */ (function () {
    function Module(moduleName) {
        this.module = new DeferredPromise();
        this.isInitializing = false;
        this.moduleName = moduleName;
    }
    Module.prototype.getModule = function () {
        if (this.module.state === DeferredPromiseStatus.Pending &&
            !this.isInitializing) {
            this.fetchModuleWithErrorHandling();
            this.isInitializing = true;
        }
        return this.module.data;
    };
    Module.prototype.fetchModuleWithErrorHandling = function () {
        var _this = this;
        this.initializeModule().catch(function (error) {
            _this.module.reject(error);
            var parsedError;
            if (error instanceof ModuleError) {
                parsedError = error;
            }
            else {
                parsedError = new ModuleError(_this.moduleName, 'Unknown_Error');
            }
            logError({
                eventName: parsedError.name,
                errorType: parsedError.getType(),
                area: parsedError.getArea(),
                message: parsedError.message,
            });
        });
    };
    Module.prototype.initializeModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('Not implemented');
            });
        });
    };
    return Module;
}());
export { Module };
//# sourceMappingURL=Module.js.map